<h2 mat-dialog-title>Se désinscrire</h2>
<mat-dialog-content class="mat-typography">
  Attention, cette action supprimera votre compte définitivement de l'application.<br>
  Souhaitez-vous réellement vous désincrire ?
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-dialog-close class="back">Annuler</button>
  <button [mat-dialog-close]="true" cdkFocusInitial class="confirm" (click)="unsubcribe()">Confirmer</button>
</mat-dialog-actions>
